import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-copy-rule-response-dialog',
    templateUrl: './copy-rule-response-dialog.component.html'
})
export class CopyRuleResponseDialogComponent {
    @Input() visible = false;
    @Input() success = [];
    @Input() failure = [];
    @Output() visibleChange = new EventEmitter<boolean>();

    close(): void {
        this.visible = false;
        this.visibleChange.emit(false);
    }
}
